<template>
  <div class="row g-3 mb-3">
    <div class="col-6 col-md-3" v-for="c in cards" :key="c.label">
      <div class="p-3 rounded bg-semi-transparent h-100 border-start border-4" :class="`border-${c.variant || 'primary'}`">
        <div class="small text-secondary">{{ c.label }}</div>
        <div class="fs-5 fw-bold">{{ c.value }}</div>
        <div class="small text-secondary" v-if="c.sub">{{ c.sub }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "kpi-cards",
  // cards: [{ label, value, sub?, variant? }]
  props: { cards: { type: Array, default: () => [] } },
};
</script>
